import { loadScript as e } from "./loadScript.mjs";
//#region src/web/sdk/loadAppleSdk.ts
var t = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
async function n() {
	if (await e(t), !window.AppleID?.auth) throw Error("Sign in with Apple JS failed to initialize");
	return window.AppleID.auth;
}
//#endregion
export { n as loadAppleSdk };
